<template>
    <div>
        <div class="w-full md:w-3/4">
            <h1 class="mt-2 mb-4 font-sans-bold">Send Agreement for Signature</h1>
            <p class="mb-5">
                If you have determined you are not the appropriate person to sign the Collaborator Agreement, please email it to the person associated with the event who is.
            </p>

            <div class="mb-12">
                <label for="signDate">
                    Email Address <span class="text-red">*</span>
                </label>
                <input id="email" type="email" name="email"
                    v-validate="'required|email'"
                    v-model="form.email">
                    <span v-show="errors.has('email')" class="error text-error-red text-lg">{{ errors.first('email') }}</span>
            </div>
            <div class="mb-12">
                <button @click="sendEmail" class="button mb-12">Send agreement for signature</button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ContractEmail',
        props: {},
        components:{},
        data: () => ({
            form: {
                email: '',            }
        }),
        computed: {
        },
        watch: {},
        methods: {
            sendEmail() {
                this.$validator.validateAll().then((result) => {
                    if (!result) {
                        return;
                    }

                    let route = this.$laroute.route('api.contracts.signature.email')

                    axios.post(route, this.form)
                    .then((response) => {
                        this.$toasted.show('Email sent.')
                        this.form.email = ''
                        this.$nextTick(() => this.$validator.reset())
                    })
                    .catch((error) => {
                        console.log(error)
                        console.log(error.response)
                    })
                })
            }
        },
        mounted() {
            this.form.key = this.$route.params.key
        }
    }
</script>
